import React, { useState, useEffect } from "react";
import { Table, Input, Select, Tooltip, Breadcrumb, Button, Spin,Layout } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
import "../../styles/Main.scss";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { SuccessNotificationMsg, ErrorNotificationMsg } from "../../utils/Notifications";
import { getRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { InfoCircleFilled } from "@ant-design/icons";

const { Option } = Select;
const { Content } = Layout;
const fetchGradeQualityOptions = async () => {
  return [
    { id: 1, grade: "FE 500D CRS (IS 1786:2008)" },
    { id: 2, grade: "FE 550D CRS (IS 1786:2008)" },
    { id: 3, grade: "FE 600 CRS (IS 1786:2008)" },
    { id: 4, grade: "FE 700 CRS (IS 1786:2008)" },
  ];
};

const fetchMaterialSizes = async () => {
  const response = await getRequest("diameter/");
  if (response && response.data && Array.isArray(response.data.data)) {
    return response.data.data
      .sort((a, b) => Number(a.value) - Number(b.value))
      .map((item) => ({
        matIndex: item.id,
        size: `${parseInt(item.value, 10)} ${(item.diameter_uom)?.toUpperCase()}`,
        pricePerKg: 0, 
        value: item.value, 
      }));
  }
  return [];
};




const NewPRReinforcementSteel = () => {
  const [tableData, setTableData] = useState([]);
  const [gradeQualityOptions, setGradeQualityOptions] = useState([]);
  const [materialSizes, setMaterialSizes] = useState([]);
  const [categoryID, setCategoryID] = useState(null);
  const [uomOptions, setUomOptions] = useState([]);
  const [apiLoading, setapiLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const companyId = authUserData()?.company;
  const navigate = useNavigate();
    const { state } = useLocation();
  const { categoryId, siteIds, selectedCategoryName } = state;

  console.log("categoryIdsss", materialSizes);


    const getSubCategory = async () => {
      setapiLoading(true);

      const form_data = new FormData();
      form_data.append('site_ids', siteIds.join(','));
  
      try {
        let apiResponse = await postRequest(`company-material-code/${categoryId}/get-pr-material-by-city/`, form_data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
        // if (prId === null || prId === undefined) {
        //   apiResponse = await getRequest(
        //     `company-material-code/1/get-pr-material-by-city/`
        //   );
        // } else {
        //   apiResponse = await getRequest(`purchase-requisition/${prId}/`);
        // }
        setCategoryID(apiResponse.data.data.category_tree_id)
        console.log('apiResponsecxz', apiResponse);
        updateTableDataOptionChange(apiResponse.data.data);
        
  
        // if (apiResponse.data.success) {
        //   setState(apiResponse.data.data);
        //   setPRView(apiResponse?.data?.data?.pr_type);
        //   const prType = apiResponse.data.data.pr_type || "City Wise";
        //   setView(prType);
        //   formRef.current.setFieldsValue({
        //     pr_view: prType,
        //   });
        // }
  
        // if (apiResponse.data.data) {
        //   const purchaseRequisitionDetails = apiResponse.data.data.map((item) => {
        //     // ff
        //   });
        //   setState((prevState) => ({
        //     ...prevState,
        //     purchase_requisition_details: purchaseRequisitionDetails,
        //   }));
        //   const uniqueSubCategories = Array.from(
        //     new Set(apiResponse.data.data.map((item) => item.sub_category))
        //   );
  
        //   setSubCategoryList(uniqueSubCategories);
        //   setSubCategoryData(apiResponse.data.data);
        //   setapiLoading(false);
        // } else {
        //   ErrorNotificationMsg(t("error_in_company_adress_list"));
        // }
        // setapiLoading(false);
        setapiLoading(false);
      
      } catch (error) {
        setapiLoading(false);
      }
    };

    useEffect(() => {
      getSubCategory()
    }, [])
  

  useEffect(() => {
    const loadData = async () => {
      try {
        const [gradeOptions, sizes] = await Promise.all([
          fetchGradeQualityOptions(),
          fetchMaterialSizes(),
        ]);

        setGradeQualityOptions(gradeOptions);
        setMaterialSizes(sizes);

        // Use static data directly
        // updateTableDataOptionChange(staticData);

      } catch (error) {
        console.error("Failed to load data:", error);
      }
    };
    loadData();
  }, []);

  const fetchUomOptions = async () => {
    try {
      const response = await getRequest("get-category-by-uom/?category_tree", { category_tree: categoryId });
      if (response?.data?.results?.data) {
        setUomOptions(response.data.results.data);
      }
    } catch (error) {
      // handle error
    }
  };

  useEffect(() => {
    fetchUomOptions();
  }, [categoryId]);

  const updateTableDataOptionChange = (state) => {
    console.log('ssastatecxz', state);
    
    const finalTableData = [];
    let cityCounter = 0;

    state?.city_wise_pr?.forEach((city) => {
      // Check if any site in the city has materials
      const cityHasMaterials = city.site_wise_details.some(site => 
        site.material_wise_details && 
        site.material_wise_details.length > 0 && 
        site.material_wise_details.some(material => 
          material.diameter_prices && 
          material.diameter_prices.length > 0
        )
      );

      if (!cityHasMaterials) return; // Skip city if no materials

      cityCounter++;
      const uniqueCityIdentifier = `city-${cityCounter}-${Date.now()}`;

      let siteCounter = 0;

      city.site_wise_details.forEach((site) => {
        const siteHasMaterials = site.material_wise_details && site.material_wise_details.length > 0;
        if (!siteHasMaterials) return;

        // Group materials by sub-category
        const materialsBySubCategory = site.material_wise_details.reduce((acc, material) => {
          const subCategory = material.material_type_sub_category;
          if (!material.diameter_prices || material.diameter_prices.length === 0) return acc;
          if (!acc[subCategory]) {
            acc[subCategory] = [];
          }
          acc[subCategory].push(material);
          return acc;
        }, {});

        if (Object.keys(materialsBySubCategory).length === 0) return; // Skip site if no valid materials

        siteCounter++;
        let materialRowCounter = 0;
        let isFirstMaterialForSite = true;

        Object.entries(materialsBySubCategory).forEach(([subCategory, materials]) => {
          materials.forEach((material, materialIndex) => {
            materialRowCounter++;
            finalTableData.push({
              srNo: `${cityCounter}.${siteCounter}.${materialRowCounter}`,
              cityId: uniqueCityIdentifier,
              cityName: city.city_name,
              siteId: site.site_id,
              siteName: site.site_name,
              key: `${uniqueCityIdentifier}-${site.site_id}-${material.material_type_id}`,
              materialDetails: {
                materialIndex: material.material_type_id,
                subCategory: material.material_type_sub_category,
                material_type_uom_name: material.material_type_uom_name,
                uom: material.material_type_uom,
                gradeQuality: material.gradeQuality || 1,
                estimated_price: material.estimated_material_unit_price,
                remark: material.material_remark,
                materialName: material.material_type_name,
                materials: material.diameter_prices.map((steel) => ({
                  matIndex: steel.diameter_id,
                  size: steel.diameter_name,
                  quantity: "",
                  pricePerKg: steel.estimated_price,
                })),
              },
              rowType: "material",
              isFirstRowForCity: siteCounter === 1 && isFirstMaterialForSite,
              isFirstRowForSite: isFirstMaterialForSite,
              isFirstRowForSubCategory: materialIndex === 0, // New flag for sub-category grouping
            });
            isFirstMaterialForSite = false;
          });
        });

        // Only add site subtotal if we added any materials
        if (materialRowCounter > 0) {
          finalTableData.push({
            srNo: "",
            cityId: uniqueCityIdentifier,
            cityName: city.city_name,
            siteId: site.site_id,
            siteName: `Sub Total for ${site.site_name} site`,
            key: `${uniqueCityIdentifier}-${site.site_id}-SiteSubTotal`,
            materialDetails: {
              subCategory: site.material_wise_details[0]?.material_type_sub_category || "Steel",
              material_type_uom_name: "KG",
              materialName: "Sub Total",
              totalAmountByKG: "0",
              totalQtyByKG: "",
              materials: materialSizes.map(({ matIndex, value, pricePerKg= 25 }) => ({
                matIndex, value, quantity: "", pricePerKg,
              })),
            },
            rowType: "siteSubTotal",
            isFirstRowForCity: false,
            isFirstRowForSite: false,
          });
        }
      });

      // Only add city total if we added any sites
      if (siteCounter > 0) {
        finalTableData.push({
          srNo: "",
          cityId: uniqueCityIdentifier,
          cityName: `City Total - ${city.city_name}`,
          siteId: null,
          siteName: "City Total",
          key: `${uniqueCityIdentifier}-CityTotal`,
          materialDetails: {
            subCategory: "Steel",
            material_type_uom_name: "KG",
            materialName: "City Total",
            cityTotalAmountForKG: "0",
            cityTotalQtyForKG: "",
            materials: materialSizes.map(({ matIndex, size, pricePerKg }) => ({
              matIndex, size, quantity: "", pricePerKg,
            })),
          },
          rowType: "cityTotal",
          isFirstRowForCity: false,
          isFirstRowForSite: false,
        });
      }
    });

    // Only add grand total if we added any cities
    if (cityCounter > 0) {
      finalTableData.push({
        srNo: "",
        cityId: null,
        // cityName: "Estimated Total",
        cityName: "Total",
        siteId: null,
        siteName: "Grand Total",
        key: "Total",
        materialDetails: {
          subCategory: "Steel",
          material_type_uom_name: "KG",
          materialName: "Grand Total",
          totalCityOverallSite: "0",
          totalQtyOverallSite: "0",
          materials: materialSizes.map(({ matIndex, size, pricePerKg }) => ({
            matIndex,
            size,
            quantity: "",
            pricePerKg,
          })),
        },
        rowType: "grandTotal",
        isFirstRowForCity: false,
        isFirstRowForSite: false,
      });
    }

    console.log("ddddddfinalTableData", finalTableData);
    setTableData(finalTableData);
  };

  const handleInputChange = (e, cityId, siteId, materialIndex, matIndex) => {
    const { value } = e.target;
    const filteredValue = value.replace(/[^0-9]/g, "");
    const numericValue = filteredValue ? parseInt(filteredValue, 10) : 0;

    if (numericValue > 9999) return;

    setTableData((prevData) =>
      prevData.map((record) => {
        if (
          record.cityId === cityId &&
          record.siteId === siteId &&
          record.materialDetails.materialIndex === materialIndex
        ) {
          return {
            ...record,
            materialDetails: {
              ...record.materialDetails,
              materials: record.materialDetails.materials.map((material) =>
                material.matIndex === matIndex
                  ? { ...material, quantity: filteredValue }
                  : material
              ),
            },
          };
        }
        return record;
      })
    );
    setTimeout(updateTotals, 0);
  };

  const handleGradeQualityChange = (value, cityId, siteId, materialIndex) => {
    setTableData((prevData) =>
      prevData.map((record) => {
        if (
          record.cityId === cityId &&
          record.siteId === siteId &&
          record.materialDetails.materialIndex === materialIndex
        ) {
          return {
            ...record,
            materialDetails: { ...record.materialDetails, gradeQuality: value },
          };
        }
        return record;
      })
    );
  };

  const handleUOMChange = (value, cityId, siteId, materialIndex, uomName) => {
    setTableData((prevData) =>
      prevData.map((record) => {
        if (
          record.cityId === cityId &&
          record.siteId === siteId &&
          record.materialDetails.materialIndex === materialIndex
        ) {
          return {
            ...record,
            materialDetails: {
              ...record.materialDetails,
              uom: value,
              material_type_uom_name: uomName,
            },
          };
        }
        return record;
      })
    );
    setTimeout(updateTotals, 0);
  };

  const handleRemarkChange = (e, cityId, siteId, materialIndex) => {
    const { value } = e.target;
    setTableData((prevData) =>
      prevData.map((record) => {
        if (
          record.cityId === cityId &&
          record.siteId === siteId &&
          record.materialDetails.materialIndex === materialIndex
        ) {
          return {
            ...record,
            materialDetails: { ...record.materialDetails, remark: value },
          };
        }
        return record;
      })
    );
  };

  const updateTotals = () => {
    setTableData((prevData) => {
      const updatedData = [...prevData];
      const cityTotals = {};
      const siteTotals = {};
      const TAX_RATE = 1.05;

      // First pass: Initialize cityTotals and siteTotals for all unique cityId and siteId combinations
      updatedData.forEach(record => {
        // Initialize cityTotals for all records with a cityId, even if it's undefined
        if (!cityTotals[record.cityId]) {
          cityTotals[record.cityId] = {
            materials: materialSizes.map(
              ({ matIndex, size, pricePerKg }) => ({
                matIndex,
                size,
                quantity: 0,
                pricePerKg,
              })
            ),
            totalAmountByKG: 0,
            totalQtyByKG: 0,
          };
        }
        // Initialize siteTotals if siteId is valid, regardless of cityId
        if (record.siteId !== null && record.siteId !== undefined) {
          const siteKey = `${record.cityId}-${record.siteId}`;
          if (!siteTotals[siteKey]) {
            siteTotals[siteKey] = {
              materials: materialSizes.map(
                ({ matIndex, size, pricePerKg }) => ({
                  matIndex,
                  size,
                  quantity: 0,
                  pricePerKg,
                })
              ),
              totalAmountByKG: 0,
              totalQtyByKG: 0,
              cityId: record.cityId, // crucial addition to siteTotals
            };
            console.log(`Debug: Initializing siteTotals for key: ${siteKey}`);
          }
        }
      });

      // Second pass: Calculate totals for material rows
      updatedData.forEach((record) => {
        if (record.rowType === "material") { // Only process material rows for accumulation
          const cityId = record.cityId;
          const siteId = record.siteId;

          let siteTotalAmount = 0;
          let siteTotalQty = 0;

          // Debug: Log the current record and its cityId when processing material rows
          // console.log('Debug: Processing material record:', record);
          // console.log('Debug: Current material record cityId:', record.cityId);

          record.materialDetails.materials.forEach((material) => {
            const qty = parseInt(material.quantity, 10) || 0;
            let totalQty = qty;
            const uom = record.materialDetails.material_type_uom_name;
            if (uom === "MT") totalQty = qty * 1000;
            else if (uom === "Bag (50 KG)") totalQty = qty * 50;
            else if (uom === "Bundle (100 KG)") totalQty = qty * 100;
            else if (uom === "KG") totalQty = qty;

            const matIndex = material.matIndex;
            // Debugging: Log cityTotals[cityId] and its materials before access
            // console.log(`Debug: cityTotals[${cityId}] (before materials access):`, cityTotals[cityId]);
            // if (cityTotals[cityId] && !cityTotals[cityId].materials) {
            //     console.error(`Debug Error: cityTotals[${cityId}].materials is missing!`, cityTotals[cityId]);
            // }
            const siteMaterialEntry = siteTotals[`${cityId}-${siteId}`]?.materials?.find(m => m.matIndex === matIndex);
            if (siteMaterialEntry) {
              siteMaterialEntry.quantity += totalQty;
            }
            siteTotalAmount += totalQty * material.pricePerKg;
            siteTotalQty += totalQty;

            const cityMaterialEntry = cityTotals[cityId]?.materials?.find(m => m.matIndex === matIndex);
            if (cityMaterialEntry) {
              cityMaterialEntry.quantity += totalQty;
            }
          });

          siteTotals[`${cityId}-${siteId}`].totalAmountByKG += siteTotalAmount;
          siteTotals[`${cityId}-${siteId}`].totalQtyByKG += siteTotalQty;
          cityTotals[cityId].totalAmountByKG += siteTotalAmount;
        }
      });

      // Correctly calculate city total quantities by summing up site total quantities
      Object.values(siteTotals).forEach((site) => {
        const cityId = site.cityId;
        if (cityTotals[cityId]) {
          cityTotals[cityId].totalQtyByKG = (cityTotals[cityId].totalQtyByKG || 0) + site.totalQtyByKG;
        }
      });

      // Third pass: Update the tableData with calculated totals
      updatedData.forEach((record, index) => {
        if (record.rowType === "siteSubTotal") {
          const siteId = record.siteId;
          const cityId = record.cityId;
          const siteKey = `${cityId}-${siteId}`;
          const siteTotalData = siteTotals[siteKey];
          if (siteTotalData) { // Check if siteTotalData exists
            updatedData[index].materialDetails.materials = siteTotalData.materials.map(m => ({ ...m, quantity: m.quantity > 0 ? m.quantity.toString() : "" }));
            updatedData[index].materialDetails.totalAmountByKG =
              siteTotalData.totalAmountByKG.toString();
            updatedData[index].materialDetails.totalQtyByKG = siteTotalData.totalQtyByKG.toString();
          }
        } else if (record.rowType === "cityTotal") {
          const cityTotalData = cityTotals[record.cityId];
          if (cityTotalData) { // Check if cityTotalData exists
            updatedData[index].materialDetails.materials = cityTotalData.materials.map(m => ({ ...m, quantity: m.quantity > 0 ? m.quantity.toString() : "" }));
            updatedData[index].materialDetails.cityTotalAmountForKG =
              cityTotalData.totalAmountByKG.toString();
            updatedData[index].materialDetails.cityTotalQtyForKG = cityTotalData.totalQtyByKG.toString();
          }
        }
      });

      // console.log('City Totals after calculation:', cityTotals);

      const grandTotal = {
        materials: materialSizes.map(({ matIndex, size, pricePerKg }) => ({
          matIndex,
          size,
          quantity: 0,
          pricePerKg,
        })),
        totalCityOverallSite: 0,
        totalQtyOverallSite: 0,
      };
      Object.values(cityTotals).forEach((city) => {
        city.materials.forEach((material) => {
          const materialEntry = grandTotal.materials.find(
            (m) => m.matIndex === material.matIndex
          );
          if (materialEntry) {
            materialEntry.quantity += material.quantity;
          }
        });
        grandTotal.totalCityOverallSite += city.totalAmountByKG;
        grandTotal.totalQtyOverallSite += city.totalQtyByKG;
      });

      const totalIndex = updatedData.findIndex((r) => r.rowType === "grandTotal");
      if (totalIndex !== -1) {
        updatedData[totalIndex].materialDetails.materials = grandTotal.materials.map(m => ({ ...m, quantity: m.quantity > 0 ? m.quantity.toString() : "" }));
        updatedData[totalIndex].materialDetails.totalCityOverallSite =
          grandTotal.totalCityOverallSite.toString();
        updatedData[totalIndex].materialDetails.totalQtyOverallSite =
          grandTotal.totalQtyOverallSite.toString();
      }

      return updatedData;
    });
  };
  console.log("tableDataxx", tableData);

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      //fixed: "left",
      width: 50,
      align: "center",
      render: (text, record) => {
        if (record.isFirstRowForCity) {
          return <span>{record.srNo.split('.')[0]}</span>;
        }
        return "";
      },
    },
    {
      title: "City",
      dataIndex: "cityName",
      width: 120,
      align: "left",
      // fixed:'left',
      render: (text, record) => {
        if (record.rowType === "grandTotal") return null;
        if (record.rowType === "cityTotal") {
          return null;
        }
        if (record.rowType === "siteSubTotal") {
          return null;
        }
        return record.isFirstRowForCity ? <span>{text}</span> : null;
      },
    },
    {
      title: "Site",
      dataIndex: "siteName",
      width: 120,
      align: "left",
      // fixed:'left',
      render: (text, record) => {
        if (record.rowType === "grandTotal") {
          return (
            <div className="totalCityOverallSitee5" style={{ 
              fontWeight: "bold",
              fontSize: "14px",
              letterSpacing: '1px',
              // padding: "8px 4px !important"
            }}>
              {record.cityName}
            </div>
          );
        }
        if (record.rowType === "cityTotal") {
          // return <div className="citytotal" style={{ fontWeight: "bold", padding: "6px 8px"  }}>{record.cityName}</div>;
          return <div className="citytotal" style={{ padding: "2px 6px"  }}>City Total</div>;

        }
        if (record.rowType === "siteSubTotal") {
          // return <div className="subtotal" style={{ fontWeight: "bold", padding: "6px 8px"  }}>{text}</div>;
          return <div className="subtotal" style={{ padding: "4px 6px"  }}>Sub Total</div>;
        }
        return record.isFirstRowForSite ? (
          <div style={{ 
            whiteSpace: 'normal', 
            wordBreak: 'break-word',
            lineHeight: '1.2',
            padding: '4px 0'
          }}>
            {text}
          </div>
        ) : null;
      },
    },
    {
      title: "Sub Category",
      dataIndex: "materialDetails",
      width: 140,
      align: "left",
      // fixed:'left',
      render: (materialDetails, record) => {
        // For total/subtotal rows, show nothing
        if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
          return null;
        }
        // Only show for first row of each sub-category group
        if (record.isFirstRowForSubCategory) {
          return (
            <span>{materialDetails?.subCategory || "-"}</span>
          );
        }
        return null;
      },
    },
    {
    title: "Grade & Quality",
    width: 190,
    dataIndex: "materialDetails",
    // fixed:'left',
    className:'stickyleft',
    
    render: (materialDetails, record) => {
      if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
        return "";
      }
      const materialsSorted = [...(materialDetails?.materials || [])].sort((a, b) => parseFloat(a.size) - parseFloat(b.size));
      
      // Split data into two columns evenly
      const totalItems = materialsSorted.length;
      const leftColumnItems = Math.ceil(totalItems / 2);
      const leftColumn = materialsSorted.slice(0, leftColumnItems);
      const rightColumn = materialsSorted.slice(leftColumnItems);

      const tooltipContent = (
        <div className="pr-tooltip-popup" style={{ minWidth: '480px' }}>
          <div className="pr-tooltip-title" style={{ marginBottom: '8px', fontWeight: 'bold' }}>
            {materialDetails?.materialName}
            {materialDetails?.subCategory ? ` - ${materialDetails.subCategory}` : ''}
          </div>
          <table className="pr-tooltip-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 2px' }}>
            <thead>
              <tr>
                <th className="diameter" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'left', width: '15%' }}>Diameter</th>
                <th className="uom" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'left', width: '15%' }}>UoM.</th>
                <th className="price" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'right', width: '15%' }}>Price/Kg</th>
                <th style={{ width: '5%', border: 'none' }}></th>
                <th className="diameter" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'left', width: '15%' }}>Diameter</th>
                <th className="uom" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'left', width: '15%' }}>UoM.</th>
                <th className="price" style={{ padding: '4px 12px', borderBottom: '2px solid #e8e8e8', textAlign: 'right', width: '15%' }}>Price/Kg</th>
              </tr>
            </thead>
            <tbody>
              {leftColumn.map((leftItem, idx) => {
                const rightItem = rightColumn[idx];
                return (
                  <tr key={idx}>
                    <td style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'left' }}>{leftItem.size.split(' ')[0]}</td>
                    <td style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'left' }}>{leftItem.size.split(' ')[1]?.toUpperCase()}</td>
                    <td className="price" style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'right' }}>₹ {leftItem.pricePerKg}</td>
                    <td style={{ border: 'none' }}></td>
                    {rightItem && (
                      <>
                        <td style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'left' }}>{rightItem.size.split(' ')[0]}</td>
                        <td style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'left' }}>{rightItem.size.split(' ')[1]?.toUpperCase()}</td>
                        <td className="price" style={{ padding: '4px 12px', background: '#f9f9f9', textAlign: 'right' }}>₹ {rightItem.pricePerKg}</td>
                      </>
                    )}
                    {!rightItem && (
                      <>
                        <td style={{ padding: '4px 12px', background: '#f9f9f9' }}></td>
                        <td style={{ padding: '4px 12px', background: '#f9f9f9' }}></td>
                        <td style={{ padding: '4px 12px', background: '#f9f9f9' }}></td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
      return (
        <div
          style={{
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
            padding: "4px 0",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          {materialDetails?.materialName}
          <Tooltip
            color="#fff"
            overlayInnerStyle={{ 
              color: "#222", 
              boxShadow: "0 2px 8px #094E8F22",
              padding: '16px',
            }}
            overlayStyle={{
              boxShadow: "0 8px 24px -12px rgba(0,0,0,0.2), 0 24px 48px 8px rgba(0,0,0,0.12), 0 36px 72px 24px rgba(0,0,0,0.08)",
              zIndex: 1050,
              filter: "drop-shadow(0 0 24px rgba(9,78,143,0.18)) drop-shadow(0 0 48px rgba(9,78,143,0.12))"
            }}
            placement="right"
            title={tooltipContent}
          >
            <InfoCircleFilled style={{ cursor: "pointer", color: "#094E8F", fontSize: 15 }} />
          </Tooltip>
        </div>
      );
    },
  },
    ...materialSizes.map(({ size, pricePerKg, matIndex }) => ({
      title: (
        <>
          {size} 
          {/* <br />₹ {pricePerKg} / Kg */}
        </>
      ),
      dataIndex: "materialDetails",
      width: 100,
      align: "center",
      render: (materialDetails, record) => {
        if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
          return "";
        }
        const material = materialDetails.materials.find((m) => m.matIndex === matIndex);
        return (
          <div className="qty-value">
            <Input
              type="text"
              min={0}
              max={9999}
              maxLength={4}
              style={{ width: "80%" }}
              value={material?.quantity || ""}
              placeholder="Qty."
              onChange={(e) =>
                handleInputChange(
                  e,
                  record.cityId,
                  record.siteId,
                  materialDetails.materialIndex,
                  matIndex
                )
              }
            />
          </div>
        );
      },
    })),
    {
      title: (
        <Tooltip
          color="#094E8F"
          overlayStyle={{
            boxShadow: "0 8px 24px -12px rgba(0,0,0,0.2), 0 24px 48px 8px rgba(0,0,0,0.12), 0 36px 72px 24px rgba(0,0,0,0.08)",
            zIndex: 1050,
            filter: "drop-shadow(0 0 24px rgba(9,78,143,0.18)) drop-shadow(0 0 48px rgba(9,78,143,0.12))"
          }}
          placement="top"
          title={<span style={{ color: "#fff" }}>Total Qty.</span>}
        >
          Qty. in Kg
        </Tooltip>
      ),
      dataIndex: "materialDetails",
      width: 90,
      align: "right",
      fixed:'right',
      render: (materialDetails, record) => {
        if (record.rowType === "siteSubTotal") {
          return "";
        }
        if (record.rowType === "cityTotal") {
          return "";
        }
        if (record.rowType === "grandTotal") {
          return "";
        }
        let total = 0;
        const uom = materialDetails.material_type_uom_name;
        if (uom === "MT") {
          total = materialDetails.materials.reduce(
            (sum, m) => sum + (parseInt(m.quantity, 10) || 0) * 1000,
            0
          );
        } else if (uom === "Bag") {
          total = materialDetails.materials.reduce(
            (sum, m) => sum + (parseInt(m.quantity, 10) || 0) * 50,
            0
          );
        } else if (uom === "KG") {
          total = materialDetails.materials.reduce(
            (sum, m) => sum + (parseInt(m.quantity, 10) || 0),
            0
          );
        }
        return (
          <div className="qty-value">
            {total.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          overlayStyle={{
            boxShadow: "0 8px 24px -12px rgba(0,0,0,0.2), 0 24px 48px 8px rgba(0,0,0,0.12), 0 36px 72px 24px rgba(0,0,0,0.08)",
            zIndex: 1050,
            filter: "drop-shadow(0 0 24px rgba(9,78,143,0.18)) drop-shadow(0 0 48px rgba(9,78,143,0.12))"
          }}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material in
              this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 100,
      dataIndex: "materialDetails",
      align: "center",
      fixed:'right',
      render: (materialDetails, record) => {
        console.log('materialddDetails', materialDetails);
        
        if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
          return "";
        }
        return (
          <div>
            <Select
              style={{ width: "100%" }}
              value={materialDetails.material_type_uom_name}
              onChange={(value) => {
                const selectedOption = uomOptions.find(
                  (option) => option.id === value
                );
                handleUOMChange(
                  value,
                  record.cityId,
                  record.siteId,
                  materialDetails.materialIndex,
                  selectedOption.unit_of_measurement
                );
              }}
            >
              {uomOptions.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option.unit_of_measurement}
                </Option>
              ))}
            </Select>
          </div>
        );
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          overlayStyle={{
            boxShadow: "0 8px 24px -12px rgba(0,0,0,0.2), 0 24px 48px 8px rgba(0,0,0,0.12), 0 36px 72px 24px rgba(0,0,0,0.08)",
            zIndex: 1050,
            filter: "drop-shadow(0 0 24px rgba(9,78,143,0.18)) drop-shadow(0 0 48px rgba(9,78,143,0.12))"
          }}
          placement="top"
          title={<span style={{ color: "#fff" }}>Estimated Amount</span>}
        >
          Est. Amount
        </Tooltip>
      ),
      dataIndex: "materialDetails",
      width: 160,
      align: "right",
      fixed:'right',
      render: (materialDetails, record) => {
        if (record.rowType === "grandTotal") {
          const amount = parseFloat(materialDetails.totalCityOverallSite) || 0;
          return (
            <div
              className="totalCityOverallSitee5" style={{ 
              fontWeight: "bold",
              fontSize: "14px",
              letterSpacing: '1px',
              width:'100%', 
              textAlign:'end'
              // padding: "8px 0"
            }}
            >
              ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
            </div>
          );
        }
        if (record.rowType === "siteSubTotal") {
          const amount = parseFloat(materialDetails.totalAmountByKG) || 0;
          return (
            <div className="subtotal1" style={{ textAlign: "end", 
            padding: "6px 8px" 
            }}>
              ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
            </div>
          );
        }
        if (record.rowType === "cityTotal") {
          const amount = parseFloat(materialDetails.cityTotalAmountForKG) || 0;
          return (
            <div className="citytotal2" 
            style={{  padding: "6px 8px"}}>
              ₹ {amount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
            </div>
          );
        }
        // For material rows: sum of (quantity in KG * pricePerKg) for each diameter
        const uom = materialDetails.material_type_uom_name;
        const totalAmount = (materialDetails.materials || []).reduce((sum, m) => {
          let qty = parseInt(m.quantity, 10) || 0;
          if (uom === "MT") qty = qty * 1000;
          else if (uom === "Bag (50 KG)") qty = qty * 50;
          else if (uom === "Bundle (100 KG)") qty = qty * 100;
          // else KG or other, qty stays as is
          const price = parseFloat(m.pricePerKg) || 0;
          return sum + qty * price;
        }, 0);
        return (
          <div style={{ marginRight: "10px" }}>
            ₹ {totalAmount.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
          </div>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "materialDetails",
      width: 170,
      align: "center",
      fixed:'right',
      render: (materialDetails, record) => {
        if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
          return null;
        }
        return (
          <div className="qty-value">
            <Input
              type="text"
              style={{ width: "150px" }}
              value={materialDetails.remark}
              placeholder="Enter Remarks"
              onChange={(e) =>
                handleRemarkChange(
                  e,
                  record.cityId,
                  record.siteId,
                  materialDetails.materialIndex
                )
              }
            />
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    console.log('stadddte', tableData);
    
  },[tableData])

  const handleSubmit = async () => {
    console.log("tablddeData", tableData);

    const state = tableData;

    // Check if any material has been used
    const hasMaterials = state.some(record => 
      record.rowType === "material" && 
      record.materialDetails.materials.some(material => 
        material.quantity && parseInt(material.quantity) > 0
      )
    );

    if (!hasMaterials) {
      // Show error message if no materials are used
      ErrorNotificationMsg("Please enter quantity for at least one material before sending for approval");
      return;
    }

    try {
      setBtnLoading(true);

      let response;

      const payload1 = {
        company: companyId ? companyId : null,
        category_tree: categoryID ? categoryID : null,
        total_amount: parseFloat(state.find((record) => record.rowType === "grandTotal")?.materialDetails.totalCityOverallSite) || 0,
        pr_site_details: (() => {
          const siteMaterialMap = {};

          state.forEach((record) => {
            if (record.rowType === "material") {
              console.log('recordddd', record);
              
              const siteId = record.siteId;
              const materialIndex = record.materialDetails.materialIndex;
              const uomId = record.materialDetails.uom;
              const remark = record.materialDetails.remark;
              const estimatedPrice = record.materialDetails.estimated_price || 0;

              console.log('auosmIddddd', uomId, );
              

              if (!siteMaterialMap[siteId]) {
                siteMaterialMap[siteId] = {};
              }
              if (!siteMaterialMap[siteId][materialIndex]) {
                siteMaterialMap[siteId][materialIndex] = {
                  total_quantity: 0,
                  total_quantity_by_kg: 0,
                  unit_of_measurement: uomId,
                  material_type_by_company: materialIndex,
                  remark: remark,
                  steel_sizes: [],
                  estimated_price: estimatedPrice,
                };
              }

              record.materialDetails.materials.forEach((diameter) => {
                const qty = parseInt(diameter.quantity, 10) || 0;
                if (qty > 0) {
                  siteMaterialMap[siteId][materialIndex].steel_sizes.push({
                    diameter_id: diameter.matIndex,
                    quantity: qty,
                  });
                }
              });

              // Calculate total_quantity and total_quantity_by_kg based on collected steel_sizes and UoM
              let currentMaterialTotalQty = 0;
              siteMaterialMap[siteId][materialIndex].steel_sizes.forEach(steel => {
                currentMaterialTotalQty += steel.quantity;
              });
              console.log('uomIdddd', uomId, uomOptions);
              
              const uomName = uomOptions.find(u => u.id === uomId)?.unit_of_measurement;
              console.log('uomNddame', uomName, uomOptions, "currentMaterialTotalQty", currentMaterialTotalQty);
              
              // Convert total quantity to KG based on UoM
              let totalQtyInKg = 0;
              if (uomName === "MT") {
                totalQtyInKg = currentMaterialTotalQty * 1000;
              } else if (uomName === "Bag (50 KG)") {
                totalQtyInKg = currentMaterialTotalQty * 50;
              } else if (uomName === "Bundle (100 KG)") {
                totalQtyInKg = currentMaterialTotalQty * 100;
              } else if (uomName === "KG") {
                totalQtyInKg = currentMaterialTotalQty;
              } else {
                // Default to KG if UoM is not recognized
                totalQtyInKg = currentMaterialTotalQty;
              }

              siteMaterialMap[siteId][materialIndex].total_quantity = currentMaterialTotalQty;
              siteMaterialMap[siteId][materialIndex].total_quantity_by_kg = totalQtyInKg;
            }
          });

          return Object.entries(siteMaterialMap)
            .map(([siteId, materials]) => ({
              site_name: Number(siteId),
              pr_material_details: Object.entries(materials)
                .filter(([, detail]) => detail.total_quantity > 0) 
                .map(([, detail]) => {
                  console.log('dddddetail', detail);
                  
                  return {
                  material_type_by_company: detail.material_type_by_company,
                  total_quantity: detail.total_quantity,
                  total_quantity_by_kg: detail.total_quantity_by_kg,
                  unit_of_measurement: detail.unit_of_measurement,
                  remark: detail.remark,
                  steel_sizes: detail.steel_sizes
                }
                }
              ),
            }))
            .filter((site) => site.pr_material_details.length > 0); // Exclude sites with no material details
        })(),
      };
      response = await postRequest("purchase-requisition/", payload1);

      if (response.data.success) {
        SuccessNotificationMsg(response.data.message);
        navigate("/purchase-requisition-history");
        setBtnLoading(false);
      } else {
        // Handle unsuccessful response
        setBtnLoading(false);
      }

      // setBtnLoading(false);
    } catch (error) {
      // setBtnLoading(false);
      console.error(error);
      setBtnLoading(false);
    }
  };

  // Add this function to render the expanded row content
  const expandedRowRender = (record) => {
    if (record.rowType !== "material") return null;
    return (
      <div style={{ display: "flex", marginLeft: 390, background: "#f6faff", borderBottom: "1px solid #e6e6e6" }}>
        {materialSizes.map(({ matIndex }, idx) => {
          const material = record.materialDetails.materials.find(m => m.matIndex === matIndex);
          return (
            <div
              key={matIndex}
              style={{
                width: 100, // match your column width for diameter columns
                textAlign: "center",
                fontWeight: "bold",
                borderRight: idx !== materialSizes.length - 1 ? "1px solid #e6e6e6" : undefined,
                padding: "8px 0"
              }}
            >
              ₹ {material?.pricePerKg ?? 0}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Purchase Requisition (PR) - {selectedCategoryName ? selectedCategoryName : ""}</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              
              <Breadcrumb.Item>
                <Link to="/purchase-requisition-history">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/create-pr">{t("Site Selection for PR")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{selectedCategoryName ? selectedCategoryName : ""}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Tooltip
            color={"#094E8F"}
            overlayStyle={{
              boxShadow: "0 8px 24px -12px rgba(0,0,0,0.2), 0 24px 48px 8px rgba(0,0,0,0.12), 0 36px 72px 24px rgba(0,0,0,0.08)",
              zIndex: 1050,
              filter: "drop-shadow(0 0 24px rgba(9,78,143,0.18)) drop-shadow(0 0 48px rgba(9,78,143,0.12))"
            }}
            placement="left"
            title={
              <span style={{ color: "#fff" }}>The unit rate or price shown in PR is estimated price for calculating PR workflows. Citywise actual buying rates can vary.</span>
            }
          >
            <Button
              className="SaveGradiantBtn"
              // onClick={handleSubmit}
              // loading={btnLoading}
            >
              {/* Save */}
              <InfoCircleFilled />
            </Button>
          </Tooltip>
        </div>
      </div>
       
  
        <section className="grid-sec mt-5 tablegridsec">
          <div className="PR-body steel-body" >
            <div className="tablewrp">
            <Table
            loading={apiLoading}
              columns={columns}
              dataSource={tableData}
              rowKey={(record) => record.key}
              pagination={false}
              bordered
              scroll={{ x: 1500 }}
              // expandable={{
              //   expandedRowRender,
              //   rowExpandable: (record) => record.rowType === "material",
              // }}
              // onRow={(record) => {
              //   if (["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)) {
              //     return {
              //       onClick: (event) => {
              //         event.stopPropagation(); // Prevent row click from affecting parent/propagating
              //       },
              //       style: { cursor: 'default' } // Change cursor to default to indicate non-interactiveness
              //     };
              //   }
              //   return {};
              // }}
            />
     </div>
      <div className="FormFooter bidftr" style={{padding:'16px 0px 0px 0px ', margin:'0'}}>
          <ButtonField
            className="CancelGradiantBtn"
            type="primary"
            htmlType="Cancel"
            label="Cancel"
            onClick={() => navigate("/purchase-requisition-history")}
          />
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            htmlType="submit"
            label="Send PR for Approval"
            loading={btnLoading}
            onClick={handleSubmit}
            // disabled={disabled}
          />
        </div>
          </div>
        </section>


    </>
  );
};

export default NewPRReinforcementSteel;
